module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "role"
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      },
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEROLES')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save'),
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.addRole({
          id: null,
          name: null,
          name_AR: null,
          status: '1',
          users: '0'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ADDNEWROLE')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar"
  }, [_c('div', {
    staticClass: "scroll-border",
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, _vm._l((_vm.roles), function(role, key) {
    return _c('el-button', {
      key: key,
      staticClass: "list",
      class: [role.id == _vm.selectedRole.id ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.loadApplication(role)
        }
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.RoleName(role))
      }
    }), (role.users > 0) ? _c('el-badge', {
      attrs: {
        "value": role.users
      }
    }) : _vm._e(), (_vm.isAllowed('delete')) ? _c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          _vm.deleteRole(key, role)
        }
      }
    }) : _vm._e(), (_vm.isAllowed('save')) ? _c('i', {
      staticClass: "fa fa-pencil",
      on: {
        "click": function($event) {
          _vm.addRole(role)
        }
      }
    }) : _vm._e()], 1)
  }))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listApplications,
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.$t(scope.row.controller.toUpperCase())) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ACTIONS')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox-group', {
          attrs: {
            "fill": "#4b4b4b",
            "border-color": "#fff",
            "text-color": "#fff"
          },
          model: {
            value: (_vm.listApplications[scope.$index]['access']),
            callback: function($$v) {
              _vm.$set(_vm.listApplications[scope.$index], 'access', $$v)
            },
            expression: "listApplications[scope.$index]['access']"
          }
        }, _vm._l((scope.row.methods), function(item, key) {
          return _c('el-checkbox-button', {
            key: key,
            attrs: {
              "disabled": _vm.disableCheckBox(scope.$index, item),
              "label": item
            },
            on: {
              "change": function($event) {
                _vm.saveRole(scope.$index)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t(key)))])
        }))]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-713c63a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Role.vue
// module id = 614
// module chunks = 1